import { CancelOutlined, Close } from "@mui/icons-material";
import {
  TextField,
  Typography,
  FormControl,
  Paper,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  FormHelperText,
  Grid2,
  InputAdornment,
  IconButton,
  Collapse,
  Alert,
} from "@mui/material";
import { FieldArray, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TheSecretRSVP() {
  const [errorSubmitting, setErrorSubmitting] = useState(false);

  const initialState = {
    names: [""],
    email: "",
    secret_rsvp: "",
    comments: "",
  };
  const navigate = useNavigate();

  const validate = (values) => {
    const errors = {};

    const name_errors = values.names.map((name) => {
      if (name === "") {
        return "Required";
      } else {
        return false;
      }
    });

    if (name_errors.some((err) => err)) {
      errors.names = name_errors;
    }

    if (!values.email) {
      errors.email = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.secret_rsvp) {
      errors.secret_rsvp = "Required";
    }

    return errors;
  };

  const handleFormSubmit = (values, actions) => {
    console.log(values);
    fetch("/secret_rsvp/submit", {
      method: "POST",
      body: JSON.stringify(values),
    }).then((res) => {
      if (res.ok) {
        navigate("/the-rsvp/submitted");
      } else {
        actions.setSubmitting(false);
        setErrorSubmitting(true);
      }
    });
  };

  return (
    <>
      <Typography align="center" variant="h3" color="secondary.main">
        The Secret RSVP
      </Typography>
      <Typography align="center" variant="h4" color="secondary.light">
        Friday September 5th, 2025
      </Typography>

      <Paper sx={{ margin: "auto", padding: 4, maxWidth: 500 }}>
        <Formik
          initialValues={initialState}
          validate={validate}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <Grid2 container spacing={2}>
              <FieldArray name="names">
                {(arrayHelpers) => (
                  <>
                    {values.names.map((name, index) => (
                      <Grid2 size={12} key={index}>
                        <FormControl fullWidth>
                          <TextField
                            color="secondary"
                            variant="standard"
                            label="Full Name"
                            id={`names.${index}`}
                            value={name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.names &&
                              touched.names[index] &&
                              errors.names &&
                              Boolean(errors.names[index])
                            }
                            helperText={
                              touched.names &&
                              touched.names[index] &&
                              errors.names &&
                              errors.names[index]
                            }
                            fullWidth
                            slotProps={
                              index !== 0
                                ? {
                                    input: {
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            size="large"
                                            color="secondary"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            <CancelOutlined />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    },
                                  }
                                : {}
                            }
                          />
                        </FormControl>
                      </Grid2>
                    ))}
                    {values.names.length < 10 && (
                      <Grid2 size={12}>
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={() => arrayHelpers.push("")}
                        >
                          Add Person
                        </Button>
                      </Grid2>
                    )}
                  </>
                )}
              </FieldArray>
              <Typography variant="body1" color="secondary.main">
                Please enter the names of all the people in your party. If your
                invitation includes a plus one, please enter their name here as
                well.
              </Typography>
              <Grid2 size={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Email"
                    id="email"
                    variant="standard"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </FormControl>
              </Grid2>
              <Grid2
                display="flex"
                justifyContent="center"
                alignItems="center"
                size={12}
              >
                <FormControl
                  error={touched.secret_rsvp && Boolean(errors.secret_rsvp)}
                >
                  <RadioGroup
                    value={values.secret_rsvp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel
                      labelPlacement="end"
                      name="secret_rsvp"
                      value="true"
                      control={<Radio />}
                      label={
                        values.names.length === 1
                          ? "I am coming! 😀"
                          : "We are coming! 😀"
                      }
                    />
                    <FormControlLabel
                      labelPlacement="end"
                      name="secret_rsvp"
                      value="false"
                      control={<Radio />}
                      label={
                        values.names.length === 1
                          ? "I can't make it 🥲"
                          : "We can't make it 🥲"
                      }
                    />
                  </RadioGroup>
                  {touched.secret_rsvp && Boolean(errors.secret_rsvp) && (
                    <FormHelperText>{errors.secret_rsvp}</FormHelperText>
                  )}
                </FormControl>
              </Grid2>
              <Grid2 size={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Other Comments"
                    variant="standard"
                    id="comments"
                    multiline
                    minRows={2}
                    maxRows={4}
                    value={values.comments}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.comments && Boolean(errors.comments)}
                    helperText={touched.comments && errors.comments}
                  />
                </FormControl>
              </Grid2>
              <Grid2 size={12}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  Submit
                </Button>
              </Grid2>
              <Grid2 size={12}>
                <Collapse in={errorSubmitting}>
                  <Alert
                    severity="error"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setErrorSubmitting(false);
                        }}
                      >
                        <Close fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Something went wrong! Please try again
                  </Alert>
                </Collapse>
              </Grid2>
            </Grid2>
          )}
        </Formik>
      </Paper>
    </>
  );
}
